import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
  className?: string;
}
export function Button({
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold transition-all duration-200 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-slate-900 text-white hover:bg-slate-800 shadow-lg hover:shadow-xl focus:ring-slate-900 border border-transparent',
    outline: 'bg-transparent text-slate-700 border-2 border-slate-200 hover:border-slate-900 hover:text-slate-900 focus:ring-slate-500',
    ghost: 'bg-transparent text-slate-600 hover:text-slate-900 hover:bg-slate-100 focus:ring-slate-500'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  // Special gradient variant override if needed, but keeping primary clean for now.
  // For the 'gradient' button requested in prompt, we'll add a specific class in usage or a new variant.
  const gradientVariant = 'bg-gradient-to-r from-purple-600 via-blue-600 to-cyan-500 text-white shadow-lg hover:shadow-purple-500/25 border-none hover:scale-105';
  const selectedVariant = variant === 'primary' && className.includes('bg-gradient') ? '' // Allow custom gradient class to override
  : variants[variant];
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${selectedVariant} ${sizes[size]} ${className}`} {...props} data-id="element-172">
      {children}
    </motion.button>;
}